import {
  Box,
  SimpleGrid,
  Image,
  LinkBox,
  LinkOverlay,
  Text,
} from '@chakra-ui/react'
import { FC } from 'react'
import { IMeshData, IModelDesignData } from '../../../../../type/designType'
import { IMesh } from '../../../../../type/modelType'
import { changeTextureByMeshName } from '../../../../../utils/design/customization'

interface IProps {
  mesh: IMesh
  designData: IModelDesignData
  setMeshData: (meshData: IMeshData) => void
}

const fieldSetStyle = {
  padding: 0,
  paddingBlock: '15px',
  borderTop: '1px solid #E2E8F0',
}

const legendStyle = {
  paddingRight: '15px',
}

export const TexturePanel: FC<IProps> = ({ mesh, designData, setMeshData }) => {
  const { textures, variants } = mesh
  const variantsMeshName = variants.map(variant => variant.meshName)
  const meshData = designData.modelConfig.meshes.find(
    m => mesh.id === m.id
  ) as IMeshData

  return (
    <Box>
      <fieldset style={fieldSetStyle}>
        <legend style={legendStyle}>Texture</legend>
        <SimpleGrid columns={4} spacing="3">
          {textures
            ?.filter(t => t.isOption)
            .map(texture => (
              <LinkBox
                key={`mesh-${mesh.id}-texture-panel-${texture.id}`}
                as="div"
                className="material-option-box"
              >
                <LinkOverlay
                  onClick={() => {
                    changeTextureByMeshName(texture, variantsMeshName)
                    delete meshData.colors
                    setMeshData({
                      ...meshData,
                      textures: [
                        {
                          id: texture.id,
                        },
                      ],
                    })
                  }}
                >
                  <Image src={texture.source.texture} shadow="md" />
                </LinkOverlay>

                <Text textAlign="center">{texture.title}</Text>
              </LinkBox>
            ))}
        </SimpleGrid>
      </fieldset>
    </Box>
  )
}
